const Textarea = ({id, label, name, formik, disabled = false, required = false, readOnly = false, isLtr = false, maxLength = '', rows = 2 }) => {
    return (
        <div className="form-group">
            <label>{label}</label>
            <textarea
                name={name}
                id={id}
                className={`form-control ${isLtr ? 'ltr-input' : ''} ${formik.errors[name] || id ? ' is-invalid' : ''}`}
                required={required}
                readOnly={readOnly}
                maxLength={maxLength}
                {...formik.getFieldProps(name)}
                rows={rows}
                disabled={disabled}
            />
            {formik.errors[name] && formik.touched[name] && (
                <small className="text-danger">{formik.errors[name]}</small>
            )}
        </div>
    );
}

export default Textarea;